import { Chip } from "@mui/material"
import type { JSX } from "react"

import type { PurchaseOrderSource, PurchaseOrderStatus } from "@crm-src/lib/purchase-orders-api"

import {
  PURCHASE_ORDER_SOURCE_LABELS,
  PURCHASE_ORDER_STATUS_COLORS,
  PURCHASE_ORDER_STATUS_LABELS,
} from "./purchase-order-format"

export function PurchaseOrderStatusChip({ status }: { status: PurchaseOrderStatus }): JSX.Element {
  return (
    <Chip
      size="small"
      data-cy="po-status"
      color={PURCHASE_ORDER_STATUS_COLORS[status] ?? "default"}
      label={PURCHASE_ORDER_STATUS_LABELS[status] ?? status}
    />
  )
}

export function PurchaseOrderSourceChip({ source }: { source: PurchaseOrderSource }): JSX.Element {
  return (
    <Chip
      size="small"
      variant="outlined"
      data-cy="po-source"
      label={PURCHASE_ORDER_SOURCE_LABELS[source] ?? source}
    />
  )
}
